import type { AccountType } from "../../constants/account-types.constants";
import type { IAssetMinimal } from "./asset.models.types";
import type { ICreatorMinimal } from "./creator.models.types";
import type { IFixedPayout, ISocial } from "./social.models.types";
import type { IUser } from "./user.models.types";

export enum PostStatus {
  draft = "draft",
  draftApproved = "draftApproved",
  draftRejected = "draftRejected",
  post = "post",
  postApproved = "postApproved",
  postRejected = "postRejected",
  disqualify = "disqualify",
  flagged = "flagged",
  flaggedReview = "flaggedReview",
  vendorDraft = "vendorDraft",
}

export interface IPostStatus {
  creator: ICreatorMinimal;
  message: string | null;
  status: string;
  timestamp: Date;
  user: string | null;
}

export interface IPostStatusLog {
  status: PostStatus;
  message: string | null;
  timestamp: Date;
  creator: ICreatorMinimal | null;
  user: IUser | null;
}

export interface IPostMetrics {
  views: number;
  likes: number;
  comments: number;
  shares: number;
}

export interface IAutoReviewStatus {
  message: string | null;
  status: string;
  timestamp: Date;
  internalMessage: string | null;
}

export interface IPostMinimal {
  id: string;
  addedByUser: {
    email: string;
    accountType: AccountType;
    name: string;
    id: string;
  } | null;
  postStatus: IPostStatus;
  creator?: ICreatorMinimal;
  draftAsset?: IAssetMinimal;
  draftDescription: string;
  liveUrl: string | null;
  eligibleForProductRefund: boolean;
  postInsight: {
    id: string;
    url: string;
    name: string;
  } | null;
  visibleToBrand: boolean;
  social: ISocial | null;
  postStatusLog: IPostStatusLog[];
  hasUserDeletedPost: boolean | null;
  userDeletedPostAt: Date | null;
  autoReviewStatus: IAutoReviewStatus | null;
  autoReviewStatusLog: Array<IAutoReviewStatus> | [];
  user: IUser;
  fixedPayout: IFixedPayout;
  metricsInstagram: IPostMetrics | null;
  metricsUpdatedAt: Date | null;
  youtube: {
    metrics: IPostMetrics | null;
  } | null;
}

export interface IPost extends IPostMinimal {}
